export const EVENTS = "/api/all-folders/:param/events"
export const EVENT = "/api/all-folders/:param/events/:eventParam"
